import { NOTE_BUTTON_ACTIONS } from 'entities/offerNote/config/constants';
import { getPhoneLinks } from 'entities/offerNote/lib/getPhoneLinks';

import type { TLinksProps } from '../types';

export const generateLinks = (
  { title, description, color, buttonLabel, linkTitle }: TLinksProps,
  phones: string[] | undefined,
) => {
  return {
    title,
    description,
    color,
    links: getPhoneLinks(phones, linkTitle),
    button: buttonLabel
      ? {
          label: buttonLabel,
          action: NOTE_BUTTON_ACTIONS.SCROLL_TO_ACTIVE,
        }
      : undefined,
  };
};
